import {$, $window, $document} from "./globals";
import YITH_WooCompare_Base from "./YITH_WooCompare";

export default class YITH_WooCompare extends YITH_WooCompare_Base {
	isMobile = null;

	init() {
		super.init();
		this.initResponsive();
	}

	initResponsive() {
		const media = window.matchMedia(
			`(max-width: 768px)`
		);

		$window
			.on( 'resize', () => {
				const isMobile = !! media.matches;

				if ( isMobile !== this.isMobile ) {
					this.isMobile = isMobile;
					this.onLayoutChange( true );
				}
			} )
			.resize();

		$document.on( 'yith_woocompare_table_updated', () => this.onLayoutChange() );
	}

	onLayoutChange( includeInitialized = false ) {
		this.isMobile || this.switchTablesToDesktop( includeInitialized );
		this.isMobile && this.switchTablesToMobile( includeInitialized );
	}

	switchTablesToDesktop( includeInitialized = false ) {
		const $tables = this.getTables( includeInitialized );

		if ( ! $tables.length ) {
			return;
		}

		$tables.get().map( table => this.switchTableToDesktop( $( table ) ) );
	}

	switchTablesToMobile( includeInitialized = false ) {
		const $tables = this.getTables( includeInitialized );

		if ( ! $tables.length ) {
			return;
		}

		$tables.get().map( table => this.switchTableToMobile( $( table ) ) );
	}

	switchTableToDesktop( $table ) {
		if ( $table.hasClass( 'dataTable' ) ) {
			$table.DataTable().destroy();
		}

		$table.find( '.label-row' ).remove();
		$table.find( 'tbody > tr > th' ).show();
		this.initTable( $table );
	}

	switchTableToMobile( $table ) {
		if ( $table.hasClass( 'dataTable' ) ) {
			$table.DataTable().destroy();
		}

		$table
			.find( 'tbody > tr:not(.product_info,.label-row)' )
			.get()
			.map( row => this.addLabelRow( $( row ) ) );

		$table.find( 'tbody > tr > th' ).hide();
		this.initTable( $table );
	}

	addLabelRow( $row ) {
		const $th = $row.find( 'th' ),
			label = $th.text(),
			$label = $( '<span/>', {
				text: label,
				class: 'label-cell',
			} ),
			$labelRow = $row.clone().addClass( 'label-row' );

		$labelRow.find( 'td' ).html( '' ).first().html( $label );

		$row.prev( '.label-row' ).remove();
		$row.before( $labelRow );
	}
}